import React, { useEffect, useState } from 'react';
import { isMobile, throttle } from 'lib/utils/UiUtils';

// Dynamic component which rendered a different child depending on mobile vs. desktop.
// Will re-render upon resize state change.
export default MobileComponent = ({ component, ...props }) => {
    const [currIsMobile, setIsMobile] = useState(isMobile());

    const onResize = throttle((e) => {
        let _isMobile = isMobile();
        if (currIsMobile != _isMobile) {
            setIsMobile(_isMobile)
        }
    });

    useEffect(() => {
        window.addEventListener('resize', onResize);

        return () => {
            window.removeEventListener('resize', onResize);
        }
    })

    if (currIsMobile) {
        return <props.mobile {...props} isMobile={currIsMobile} />
    } else {
        return <props.normal {...props} isMobile={currIsMobile} />
    }
};